/* eslint-disable @typescript-eslint/no-empty-function */
import React from "react";
import { ButtonRow } from "../../../designSystem/button/ButtonRow";
import { H2, H3 } from '../../../designSystem/typography/Heading';
import { ListRowStyleVariant, ListRow } from "../../../designSystem/compositeComponents/ListRow";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";

export const ListRowOverview = (): JSX.Element =>
{

    return (
        <>
            <ButtonRow variant={"left-aligned"}>
                <H2>ListRow</H2>
            </ButtonRow>

            <Flex flexDirection="column" gap={10}>
                {['normal', 'lightGray'].map((styleVariant, i1) =>
                {
                    return [1, 2, 3].map((level, i2) =>
                    {
                        return [undefined, '16px'].map((padding, i3) =>
                        {
                            return (
                                <div key={`${i1}-${i2}-${i3}`}>
                                    <H3>
                                        styleVariant: {styleVariant} | padding: {padding || 'undefined'}
                                    </H3>
                                    <ListRow
                                        styleVariant={styleVariant as ListRowStyleVariant}
                                        padding={padding}
                                        stripColor={'yellow'}
                                        level={level as 1 | 2 | 3}
                                        onClick={() => alert('clicked!')}
                                        content={
                                            <>
                                                level 1 | no children| yellow strip | onClick alert
                                                
                                            </>
                                        }
                                    />
                                    <ListRow
                                        styleVariant={styleVariant as ListRowStyleVariant}
                                        padding={padding}
                                        level={level as 1 | 2 | 3}
                                        onClick={() => alert('clicked!')}
                                        content={
                                            <>
                                                level 1 | with children | no strip color | no onClick
                                                
                                            </>
                                        }
                                        childRows={
                                            <ListRow 
                                                styleVariant={styleVariant as ListRowStyleVariant}
                                                padding={padding}
                                                stripColor={'blue'}
                                                level={2}
                                                onClick={() => alert('clicked!')}
                                                content={
                                                    <>
                                                        level 2 | with children | blue strip | onClick alert
                                                    </>
                                                }
                                                childRows={
                                                    <ListRow
                                                        styleVariant={styleVariant as ListRowStyleVariant}
                                                        padding={padding}
                                                        stripColor={'green'}
                                                        level={3}
                                                        onClick={() => alert('clicked!')}
                                                        content={
                                                            <>
                                                                level 3 | no children | green strip | onClick alert
                                                            </>
                                                        }
                                                    >

                                                    </ListRow>
                                                }
                                                />
                                        }
                                    />
                                </div>
                            );
                        });
                    });
                })}
            </Flex>

        </>
    );
};